import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { config } from 'src/config/config';

import { mediaQueries } from '../styles/variables';

import appStoreButton from 'src/public/img/btn-appstore.svg';
import googlePlayButton from 'src/public/img/btn-google-play.svg';
import image from 'src/public/img/mobile-modal-qr-code.png';
import {
    BodyTextMedium as BodyTextMediumBase,
    HeadingText40,
    Modal,
    pxToRem,
} from '@modernhealth/vital-components';

interface MobileAppInformationModalProps {
    isVisible: boolean;
    onModalClose: () => void;
}

const QrCodeBackground = styled.img({
    width: '100%',
    maxHeight: '30vh',
    objectFit: 'cover',
    borderTopLeftRadius: pxToRem(20),
    borderTopRightRadius: pxToRem(20),
});

const ContentWrapper = styled.div({
    padding: pxToRem(22, 52),
});

const ButtonsWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2em',
});

const BodyTextMedium = styled(BodyTextMediumBase)({
    margin: '0 auto',
});

const StoreButton = styled.img({
    cursor: 'pointer',
    maxHeight: pxToRem(48),
    [mediaQueries.sm]: {
        width: pxToRem(130),
    },
});

export const MobileAppInformationModal: React.FC<MobileAppInformationModalProps> = ({
    isVisible,
    onModalClose,
}) => {
    const { t } = useTranslation();

    const handleStoreButtonClick = (link: string) => () => {
        onModalClose();

        window.open(link, '_blank');
    };

    return (
        <Modal onCloseButtonClick={onModalClose} noPaddings maxWidth={558} isVisible={isVisible}>
            <QrCodeBackground src={image} alt="smartphone showing match with coach" />
            <ContentWrapper>
                <HeadingText40 marginBottom={12} centered>
                    {t('shared:mobile_app_info_modal.download_our_app')}
                </HeadingText40>
                <BodyTextMedium centered maxWidth="454px">
                    {t('shared:mobile_app_info_modal.mobile_app_perks')}
                </BodyTextMedium>
                <ButtonsWrapper>
                    <StoreButton
                        src={appStoreButton}
                        style={{ marginRight: 15 }}
                        onClick={handleStoreButtonClick(config.iOSAppStoreURL)}
                    />
                    <StoreButton
                        src={googlePlayButton}
                        onClick={handleStoreButtonClick(config.AndroidGooglePlayStoreURL)}
                    />
                </ButtonsWrapper>
            </ContentWrapper>
        </Modal>
    );
};
